import React, { useState } from "react";

import AntDLayout from "antd/es/layout";

import ChatButtonOffsetContext from "@app/component/chat/buttonOffset/ChatButtonOffsetContext";
import createChatButtonOffsetChannel from "@app/component/chat/buttonOffset/createChatButtonOffsetChannel";
import GlobalSearch from "@app/component/GlobalSearch";
import NotificationBouncedEmailModal from "@app/component/notification/NotificationBouncedEmailModal";
import NotificationCadenceModal from "@app/component/notification/NotificationCadenceModal";
import SavedLocationNamingCard from "@app/component/savedLocations/SavedLocationNamingCard";

import AnnouncementsGate from "../announcements/AnnouncementsGate";
import ChatWidgetGate from "../chat/ChatWidgetGate";
import GlobalCreateEntityModals from "../createEditEntity/GlobalCreateEntityModals";
import EmailComposeModalsProvider from "../email/creation/EmailComposeModalsProvider";
import EmailFeaturesModal from "../email/EmailFeaturesModal";
import EmailTemplatesModalProvider from "../email/EmailTemplatesModalProvider";
import Guides from "../flows/Guides";
import NavigationBar from "../NavigationBar";

import AccessChangeBar from "./components/AccessChangeBar";
import FrequencyModalWrapper from "./components/FrequencyModalWrapper";
import PreviewEditPanes from "./components/PreviewEditPanes";
import RecordLimitAlert from "./components/RecordLimitAlert";
import SandboxInfoBar from "./components/SandboxInfoBar";
import TrialExpiration from "./components/TrialExpiration";
import UserLocationRequest from "./components/UserLocationRequest";
import { ReactComponent as GradientSvg } from "./gradient.svg";
import styles from "./Layout.module.scss";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  // useState initializer, not useMemo: React may discard memo results, and this channel
  // holds live sidebar contributions that must survive the whole session.
  const [chatButtonOffsetChannel] = useState(createChatButtonOffsetChannel);

  return (
    <ChatButtonOffsetContext.Provider value={chatButtonOffsetChannel}>
      <EmailComposeModalsProvider>
        <EmailTemplatesModalProvider>
          <AntDLayout className={styles.container}>
            <NavigationBar />
            <TrialExpiration />
            <RecordLimitAlert />
            <UserLocationRequest />
            <SandboxInfoBar />
            <AccessChangeBar />
            <PreviewEditPanes />
            <NotificationBouncedEmailModal />
            <NotificationCadenceModal />
            <GlobalSearch />
            <SavedLocationNamingCard />
            <FrequencyModalWrapper />
            <EmailFeaturesModal />
            <AnnouncementsGate />
            <Guides />
            <GlobalCreateEntityModals />
            <ChatWidgetGate />
            <AntDLayout.Content className={styles.content}>
              {/* Note: this GradientSvg is used as a pattern holder, which is then used in different
             components, e.g., in
             /scene/dashboard/components/addEditCard/AddCardWizard/components/SelectCardStep/components/CardItem.tsx
             component (refer its styles). But since we refer a pattern by ID, it's better to include it
             only once, in one of the parent components, rather than doing in every CardItem which would lead to
             technically invalid HTML. */}
              <GradientSvg className={styles.gradientHolder} />
              <div className={styles.contentWrapper}>{children}</div>
            </AntDLayout.Content>
          </AntDLayout>
        </EmailTemplatesModalProvider>
      </EmailComposeModalsProvider>
    </ChatButtonOffsetContext.Provider>
  );
};

export default Layout;
